/* eslint-disable global-require */
import React, { useEffect } from 'react'
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Col,
  Container,
} from 'reactstrap'
import { useOktaAuth } from '@okta/okta-react'
import Background from '../../assets/img/wic/Fruits_slides.jpg'
import PropTypes from 'prop-types'

const LogoutPage = ({ history }) => {
  useEffect(() => {
    document.body.classList.toggle('lock-page')
    return () => {
      document.body.classList.toggle('lock-page')
    }
  })

  const { oktaAuth } = useOktaAuth()

  const logoutWithOkta = async () => oktaAuth.signOut('/')

  const handleYesClick = e => {
    e.preventDefault()
    logoutWithOkta()
    history.push('/')
  }

  const handleNoClick = e => {
    e.preventDefault()
    history.push('/')
  }

  return (
    <div className="lock-page">
      <Container>
        <Col className="ml-auto mr-auto" lg="4" md="6">
          <Card className="card-lock text-center">
            <CardBody>
              <CardTitle tag="h4">Are you sure you want to logout?</CardTitle>
            </CardBody>
            <CardFooter>
              <div className="update btn-group-horizontal">
                <Button
                  className="btn-round mr-2"
                  color="primary"
                  onClick={handleYesClick}
                >
                  <i className="fa fa-check" /> Yes
                </Button>
                <Button
                  className="btn-round ml-2"
                  color="danger"
                  onClick={handleNoClick}
                >
                  <i className="fa fa-times" /> Cancel
                </Button>
              </div>
            </CardFooter>
          </Card>
        </Col>
      </Container>
      <div
        className="full-page-background"
        style={{
          backgroundImage: `url(${Background})`,
          opacity: 0.4,
        }}
      />
    </div>
  )
}

LogoutPage.propTypes = {
  history: PropTypes.any,
}

export default LogoutPage
